'use strict';

require('./IconsAndSectionsAdmin.scss');

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    Constants = require('constants/AppConstants'),
    ContentUtils = require('utils/ContentUtils'),
    AdminScaffoldingGeneric = require('components/Commons/AdminScaffolding/AdminScaffoldingGeneric'),
    Loading = require('components/Commons/Loading/Loading'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    Authentication = require('services/Security').Authentication,
    InventoryStore = require('stores/InventoryStore'),
    DashboardStore = require('stores/DashboardStore'),
    FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
    AppConstants = require('constants/AppConstants'),
    GridItemWithFilter = require('components/Commons/GridItem/GridItemWithFilter'),
    ga = require('react-ga'),
    _ = require('lodash');

const IconsAndSectionsAdmin = React.createClass({displayName: "IconsAndSectionsAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder],

    getInitialState() {
        return {
            sectionSelected: Constants.BREWING_SECTION_NAME,
            selectedIcon: Constants.BREWING_SECTION_NAME,
            isEditMode: false,
            iconsMapping: null,
            filterText: null
        };
    },

    componentDidMount() {
        this.fetchIcons();
        ga.pageview('/icons-section-admin');
    },

    fetchIcons() {
        const self = this;
        InventoryStore.fetchIcons(function (response) {
            const icons = ContentUtils.formatApplicantIcons(response.icons, response.iconsFromApplicant);
            const iconsFiltered = _.filter(icons, icon => _.get(icon, 'iconDetail.name') !== Constants.TASK_NON_VISIBLE); // remove only this icons
            const iconsSorted = _.orderBy(iconsFiltered, 'iconDetail.name');
            const iconsPristine = _.cloneDeep(iconsSorted);
            self.setState({
                icons: iconsSorted,
                iconsPristine,
                iconsChanged: [] // clean icon changed
            });
        });
    },

    _saveChanges(icon, onSuccess, onFailure) {
        const {icons, iconsPristine} = this.state;
        const iconMappingConverted = InventoryStore.filterOnlyIconsChanged(icons, iconsPristine);
        InventoryStore.changeIcon({
            iconsChanged: iconMappingConverted
        }, onSuccess, onFailure);
        DashboardStore.updateDashboardContent();
    },


    _onChangeSection(evt, index, value) {
        this.setState({
            sectionSelected: _.get(value, 'itemModel.section')
        });
    },

    _onCancel() {
        this.fetchIcons();
        this.setState({
            filterText: ''
        });
    },

    _onCheckIcon(gridItemProps, filterText) {
        const {iconId} = gridItemProps;
        const {sectionSelected, icons} = this.state;

        // update state of icon
        let currentIconChecked = _.find(this.state.icons, icon => icon.id === iconId);
        const oldStateIcon = isCheckedIcon(sectionSelected, currentIconChecked);
        const newStateIcon = !oldStateIcon;
        currentIconChecked = updateSectionIcon(sectionSelected, currentIconChecked, newStateIcon);

        const iconsFiltered = _.filter(icons, icon => icon.id !== currentIconChecked.id);
        const allIconsWithIconUpdated = _.concat(iconsFiltered, currentIconChecked);

        this.setState({
            icons: _.orderBy(allIconsWithIconUpdated, 'iconDetail.name'),
            iconsChanged: this.getIconChangedUpdated(currentIconChecked),
            filterText
        });
    },

    getIconChangedUpdated(iconChangedNew) {
        const {sectionSelected, iconsChanged, iconsPristine} = this.state;

        // find if already change the icon
        const iconChangedOld = _.find(iconsChanged, iconChanged => _.get(iconChanged, 'id') === _.get(iconChangedNew, 'id'));
        const existIconChanged = !!iconChangedOld;

        // ask if we apply the same change that before
        const isSomeStateIconChanged = isSameStateIcon(iconChangedOld, iconChangedNew, sectionSelected);
        let iconChangedUpdated;

        if (existIconChanged && isSomeStateIconChanged) {
            // we don't need to change nothing because is the same state
            iconChangedUpdated = iconsChanged;
        } else if (existIconChanged && isSomeStateIconChanged === false) {
            // we need to update the changed icon
            const iconsChangedFiltered = _.filter(iconsChanged, iconChanged => _.get(iconChanged, 'id') !== _.get(iconChangedNew, 'id'));
            iconChangedUpdated = _.concat(iconsChangedFiltered, iconChangedNew);
        } else if (!existIconChanged) {
            // just need to add the new changed icon
            iconChangedUpdated = _.concat(iconsChanged, iconChangedNew);
        } else {
            // we don't need to do nothing
            iconChangedUpdated = iconsChanged;
        }

        // filter all icon changed which have the same state of icon pristine
        iconChangedUpdated = _.filter(iconChangedUpdated, iconChanged => {
            const iconPristine = _.find(iconsPristine, iconPristine => _.get(iconPristine, 'id') === _.get(iconChanged, 'id'));
            const isSameStateIconPristine = isSameStateIcon(iconPristine, iconChanged, sectionSelected);
            return !isSameStateIconPristine;
        });

        // add where section came from the icon changed
        iconChangedUpdated = _.map(iconChangedUpdated, icon => {
            icon.sectionChanged = sectionSelected;
            return icon;
        });

        return iconChangedUpdated;
    },

    isChangedIcon(icon) {
        const {iconsChanged, sectionSelected} = this.state;
        const isChangedIcon = !!_.find(iconsChanged, iconChanged => _.get(iconChanged, 'id') === _.get(icon, 'id') && _.get(iconChanged, 'sectionChanged') === sectionSelected);

        return isChangedIcon;
    },

    render() {
        if (!this.state.icons) {
            return (React.createElement(Loading, null));
        } else {
            const messages = {
                changeSuccessMessage: t('icons_and_sections_admin_change_success'),
                changeFailureMessage: t('icons_and_sections_admin_change_failure'),
                addSuccessMessage: t('icons_and_sections_admin_delete_success'),
                addFailureMessage: t('icons_and_sections_admin_add_failure')
            };
            const contextHolder = this.getContextHolderInstance();
            let {selectedIcon, isEditMode, icons, sectionSelected, iconsPristine} = this.state;
            const originalStateIcons = isOriginalState(icons, iconsPristine, sectionSelected);
    
            const currentSelectedSection = selectedIcon && selectedIcon.section
              ? AppConstants.getSectionsMapping(t)[selectedIcon.section]
              : '';
    
            const currentSelectedCategoryValue = currentSelectedSection
              ? Object.assign({}, selectedIcon, {displayText: currentSelectedSection})
              : selectedIcon;
            
            const formFieldsEl = [
                React.createElement(FormGroupDropdown, {
                    isFullRelaxedText: true, 
                    items: AppConstants.getSections(t), 
                    operationsHolder: contextHolder, 
                    readerAttribute: "displayText", 
                    customReaderWriterAttribute: "section", 
                    readerAttributeValue: "section", 
                    writerAttribute: "type", 
                    outputMapper: {
                        Fermenting: 'FV',
                        Packaging: 'BT',
                        Brewing: 'BH'
                    }, 
                    name: t('icons_and_sections_admin_section_label'), 
                    isImmutable: true, 
                    value: sectionSelected, 
                    isEditMode: isEditMode, 
                    onChange: this._onChangeSection}
                )
            ];

            return (
                React.createElement(AdminScaffoldingGeneric, {
                    title: t('icons_and_sections_admin_title'), 
                    moduleName: "ADMIN_ICON", 
                    messages: messages, 
                    contextHolder: contextHolder, 
                    value:  originalStateIcons ? undefined : currentSelectedCategoryValue, 
                    fetchItems:  this.fetchIcons, 
                    headerFields: formFieldsEl, 
                    onChange:  originalStateIcons ? undefined : this._saveChanges, 
                    onCancel:  originalStateIcons ? undefined : this._onCancel, 
                    isMultiSelection: true
                }, 
                    React.createElement(GridItemWithFilter, {
                        items: translateIcons(icons, t), 
                        isCheckedItem: isCheckedIcon.bind(this, sectionSelected), 
                        isChangedItem: this.isChangedIcon, 
                        onCheckItem: this._onCheckIcon, 
                        displayNameField: "iconDetail.displayNameText", 
                        iconClassNameField: "iconDetail.iconClassName", 
                        idField: "iconDetail.id", 
                        initialFilterText: this.state.filterText, 
                        nonMatchingText: t('icons_and_sections_non_matching'), 
                        keepSelectedSorting: false}
                    )
                )
            );
        }
    }
});

function translateIcons(icons, t) {
    return icons.map(icon => {
        icon.iconDetail.displayNameText = Constants.getIconsMapping(t)[icon.iconDetail.displayName] || icon.iconDetail.displayName;
        return icon;
    });
}

function isOriginalState(iconsChanged, iconPristine, currentSection) {
    return _.every(iconsChanged, iconChanged => {
        const iconCompare = _.find(iconPristine, iconPristine => iconPristine.id === iconChanged.id);
        return isSameStateIcon(iconCompare, iconChanged, currentSection);
    });
}

function isSameStateIcon(icon, iconCompare, currentSection) {
    if (icon && iconCompare) {
        const isCheckedIconCompare = isCheckedIcon(currentSection, iconCompare);
        const isCheckedIconChanged = isCheckedIcon(currentSection, icon);
        const isSameState = isCheckedIconCompare === isCheckedIconChanged;
        return isSameState;
    }
}

function isCheckedIcon(currentSection, icon) {
    switch (currentSection) {
        case Constants.BREWING_SECTION_NAME:
            return _.get(icon, 'iconDetail.isBrewingAllowed');
        case Constants.FERMENTING_SECTION_NAME:
            return _.get(icon, 'iconDetail.isFermentingAllowed');
        case Constants.PACKAGING_SECTION_NAME:
            return _.get(icon, 'iconDetail.isPackagingAllowed');
    }
}

function updateSectionIcon(currentSection, icon, newCheckedState) {
    switch (currentSection) {
        case Constants.BREWING_SECTION_NAME:
            return _.set(icon, 'iconDetail.isBrewingAllowed', newCheckedState);
        case Constants.FERMENTING_SECTION_NAME:
            return _.set(icon, 'iconDetail.isFermentingAllowed', newCheckedState);
        case Constants.PACKAGING_SECTION_NAME:
            return _.set(icon, 'iconDetail.isPackagingAllowed', newCheckedState);
    }
}

module.exports = IconsAndSectionsAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/IconsAndSectionsAdmin/IconsAndSectionsAdmin.jsx
 **/